export default __webpack_public_path__ + "static/media/LOGO.2e77e9b4.jpeg";